import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "antd/lib/tooltip";
import {
  setWidgetMakerGraphData,
  setWidgetMakerShareGraphData,
  setWidgetMakerSharePageGraphData,
  setPageChart,
  getDeepDive,
} from "../../redux/actions/WidgetMaker/WidgetAPI";
import {
  setFilterObj,
  setPostCardOrderBy,
  setY_attribute,
} from "../../redux/actions/WidgetMaker/GraphConfig";
import { FilterPillsDeepDiveResponse } from "../../redux/actions/dashboard/Tab1";
import {
  getAllFilters,
  getAllShareFilters,
  getAllTemplateFilters,
  getGlobalBrands,
  getPaneIndex,
  getWidgetGraphObject,
  kFormatter,
  useQuery,
} from "../../redux/constants";
import { setDeepDiveInfoLoader } from "../../redux/actions/DeepDive";
import {
  setDeepDiveInfluencersObject,
  setDeepDiveObject,
} from "../../redux/actions/WidgetMaker/WidgetMaker";
import isEqual from "react-fast-compare";
import IsEmpty from "../utils/IsEmpty";
import { setSortByChangeInMetaDataInDeepDiveDashboard } from "../../redux/actions/DeepDiveDashboard/DeepDiveDashboard";

const PostCardFilters = ({
  filterPills,
  metadata,
  section_index,
  widget_index,
  deepDive,
  isPreviewState,
  PdfDownloadStatus,
  PptGeneratingStatus,
  widget_id,
  chart_type,
}) => {
  const dispatch = useDispatch();
  let query = useQuery();
  const deepdive_object = useSelector(
    (state) => state.WidgetMaker.deepdive_object
  );
  const influencers_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_influencers_object
  );
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const Section = useSelector((state) => state.Section.addSection);
  const [pillsName, setPillsName] = useState(null);

  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );

  // This state store attribute list in dashboard case allAttributes
  // This state store attribute list in widget maker case All_WM_attributes
  let allAttributesList = allAttributes ? allAttributes : All_WM_attributes;

  const postCardFilter = (name) => {
    let index = getPaneIndex(panes, activeKey);
    let pathName = window.location.pathname?.split("/")?.[1];
    if (pathName === "edit-dashboard" || pathName === "create-dashboard") {
      // Create And Edit Dashboard View
      setPillsName(name);
      if (metadata) {
        let filter_by_data;
        let postcard_pills_filter;
        let updatedOrderBy;
        if (name === null) {
          updatedOrderBy = {
            attribute: metadata?.order_by?.attribute,
            sort_order: metadata?.order_by?.sort_order,
            offset: 0,
          };
          filter_by_data = null;
          postcard_pills_filter = null;
        } else {
          let attName = metadata?.y_axes
            ? metadata?.y_axes[0]?.attribute
            : widgetGraphConfig?.filter_by?.length > 0 &&
              widgetGraphConfig?.filter_by[0]?.attribute;
          if (metadata?.y_axes?.length > 0) {
            filter_by_data = {
              attribute:
                !metadata && widgetGraphConfig?.filter_by
                  ? widgetGraphConfig?.filter_by?.[0]?.attribute
                  : metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
              data: filterPills,
            };
            postcard_pills_filter = {
              attribute: attName,
              type: "varchar",
              columns: [{ name: name, type: "include" }],
            };
          }
          updatedOrderBy = {
            attribute: metadata?.order_by?.attribute,
            sort_order: metadata?.order_by?.sort_order,
            offset: 0,
          };
        }

        if (metadata) {
          let updatedSection = [...Section];
          if (section_index >= 0) {
            if (
              metadata?.chart?.chart_type === "post-card" ||
              metadata?.chart?.chart_type === "review-card"
            ) {
              updatedSection[section_index].data[widget_index].order_by =
                updatedOrderBy;
            }
            if (metadata?.y_axes?.length) {
              updatedSection[section_index].data[widget_index].filter_by_data =
                filter_by_data;
              updatedSection[section_index].data[widget_index].filter_by =
                postcard_pills_filter;
            }

            if (metadata?.data) {
              updatedSection[section_index].data[widget_index].data = null;
            }
          } else {
            if (
              metadata?.chart?.chart_type === "post-card" ||
              metadata?.chart?.chart_type === "review-card"
            ) {
              updatedSection[0].data[widget_index].order_by = updatedOrderBy;
            }
            if (metadata?.y_axes?.length) {
              updatedSection[0].data[widget_index].filter_by_data =
                filter_by_data;
              updatedSection[0].data[widget_index].filter_by =
                postcard_pills_filter;
            }
            if (metadata?.data) {
              updatedSection[0].data[widget_index].data = null;
            }
          }
          dispatch({ type: "SET_ADDSECTION", payload: updatedSection });
        }
      }
    } else if (
      !deepDive &&
      (((pathName === "dashboard" || pathName === "pin-dashboard") &&
        !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
        panes?.[index]?.isDeepDiveDashboard) ||
        shareTemplateData?.isDeepDiveDashboard ||
        screen?.isDeepDiveDashboard)
    ) {
      // DeepDive Dashboard View
      setPillsName(name);
      let filter_by_data;
      let postcard_pills_filter;
      let updatedOrderBy;
      if (name === null) {
        updatedOrderBy = {
          attribute: metadata?.order_by?.attribute,
          sort_order: metadata?.order_by?.sort_order,
          offset: 0,
        };
        filter_by_data = null;
        postcard_pills_filter = null;
      } else {
        let attName = metadata?.y_axes?.[0]?.attribute;
        if (metadata?.y_axes?.length > 0) {
          filter_by_data = {
            attribute: metadata?.y_axes?.[0]?.attribute,
            data: filterPills,
          };
          postcard_pills_filter = {
            attribute: attName,
            type: "varchar",
            columns: [{ name: name, type: "include" }],
          };
        }
        updatedOrderBy = {
          attribute: metadata?.order_by?.attribute,
          sort_order: metadata?.order_by?.sort_order,
          offset: 0,
        };
      }
      if (metadata) {
        dispatch(
          setSortByChangeInMetaDataInDeepDiveDashboard(
            section_index,
            widget_index,
            true, // TO BE CLEAR GRAPGH DATA
            "CARD_FILTER_PILL_CHANGE",
            {
              order_by: updatedOrderBy,
              filter_by_data:
                metadata?.y_axes?.length && filter_by_data
                  ? filter_by_data
                  : null,
              filter_by:
                metadata?.y_axes?.length && postcard_pills_filter
                  ? postcard_pills_filter
                  : null,
            }
          )
        );
      }
    } else if (deepDive) {
      setPillsName(name);
      if (name === null) {
        let widget_ids = [widget_id];
        let arrr = {
          ...deepdive_object,
          tabName: widget_id === "1.1" ? "Mentions" : "Influencers",
          filter_by_data: null,
          filter_by: null,
          deepdive_on: {
            ...deepdive_object.deepdive_on,
            order_by: {
              attribute: "engagement",
              sort_order: "desc",
              offset: 0,
            },
          },
          shareTemplateData: shareTemplateData,
          shareBrands: shareBrands,
        };
        dispatch(setDeepDiveObject(arrr));
        dispatch(setDeepDiveInfoLoader(true));

        if (pathName?.toLowerCase() === "CommandCenter"?.toLowerCase()) {
          if (widget_id === "4.1") {
            let deep_dive_obj = { influencers: [] };
            dispatch({
              type: "SET_DEEP_DIVE_DATA_IN_SCREEN",
              isDeepDive: true,
              deep_dive: deep_dive_obj,
            });
          }

          arrr.screen = screen;
          // console.log("arrr", arrr);
          dispatch(getDeepDive(authParams, arrr, widget_ids));
        } else {
          dispatch(
            FilterPillsDeepDiveResponse(
              panes,
              index,
              authParams,
              arrr,
              widget_ids,
              query?.get("share_id")
            )
          );
        }
      } else {
        let widget_ids = [widget_id];
        let influencers_att_name = "InfluencerCategory";
        let filter_by_data = {
          attribute: influencers_att_name,
          data: filterPills,
        };
        let postcard_pills_filter = {
          attribute: influencers_att_name,
          type: "varchar",
          columns: [{ name: name, type: "include" }],
        };

        let influencers_data = {
          ...influencers_object,
          tabName: widget_id === "1.1" ? "Mentions" : "Influencers",
          filter_by_data: filter_by_data,
          filter_by: postcard_pills_filter,
          deepdive_on: {
            ...influencers_object?.deepdive_on,
            order_by: {
              attribute:
                deepDive &&
                widget_id === "4.1" &&
                influencers_object?.deepdive_on?.order_by?.attribute
                  ? influencers_object?.deepdive_on?.order_by?.attribute
                  : "engagement",
              sort_order:
                deepDive &&
                widget_id === "4.1" &&
                influencers_object?.deepdive_on?.order_by?.sort_order
                  ? influencers_object?.deepdive_on?.order_by?.sort_order
                  : "desc",
              offset: 0,
              widget_ids: widget_ids[0],
            },
          },
          shareTemplateData: shareTemplateData,
          shareBrands: shareBrands,
        };

        widget_id === "4.1" &&
          dispatch(
            setDeepDiveInfluencersObject(influencers_data, panes, index)
          );
        dispatch(setDeepDiveInfoLoader(true));

        if (pathName?.toLowerCase() === "CommandCenter"?.toLowerCase()) {
          if (widget_id === "4.1") {
            let deep_dive_obj = { influencers: [] };
            dispatch({
              type: "SET_DEEP_DIVE_DATA_IN_SCREEN",
              isDeepDive: true,
              deep_dive: deep_dive_obj,
            });
          }

          influencers_data.screen = screen;
          // console.log("influencers_data", influencers_data);
          dispatch(getDeepDive(authParams, influencers_data, widget_ids));
        } else {
          dispatch(
            FilterPillsDeepDiveResponse(
              panes,
              index,
              authParams,
              influencers_data,
              widget_ids,
              query?.get("share_id")
            )
          );
        }
      }
    } else if (shareTemplateData) {
      // Share Dashboard View
      setPillsName(name);
      let filter_by_data;
      let postcard_pills_filter;
      let updatedOrderBy;
      if (name === null) {
        updatedOrderBy = {
          attribute: metadata?.order_by?.attribute,
          sort_order: metadata?.order_by?.sort_order,
          offset: 0,
        };
        filter_by_data = null;
        postcard_pills_filter = null;
      } else {
        let attName = metadata?.y_axes ? metadata?.y_axes[0]?.attribute : null;
        if (metadata?.y_axes?.length > 0) {
          filter_by_data = {
            attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
            data: filterPills,
          };
          postcard_pills_filter = {
            attribute: attName,
            type: "varchar",
            columns: [{ name: name, type: "include" }],
          };
        }

        updatedOrderBy = {
          attribute: metadata?.order_by?.attribute,
          sort_order: metadata?.order_by?.sort_order,
          offset: 0,
        };
      }
      if (metadata) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0) {
          if (
            metadata?.chart?.chart_type === "post-card" ||
            metadata?.chart?.chart_type === "review-card"
          ) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].order_by = updatedOrderBy;
          }
          if (metadata?.y_axes?.length) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].filter_by_data = filter_by_data;
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].filter_by = postcard_pills_filter;
          }

          if (metadata?.graphData) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
          if (metadata?.persist_graphdata) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (metadata?.deep_dive_on) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        } else {
          if (
            metadata?.chart?.chart_type === "post-card" ||
            metadata?.chart?.chart_type === "review-card"
          ) {
            updateShareTemplateData.section[0].widgets[widget_index].order_by =
              updatedOrderBy;
          }
          if (metadata?.y_axes?.length) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].filter_by_data = filter_by_data;
            updateShareTemplateData.section[0].widgets[widget_index].filter_by =
              postcard_pills_filter;
          }
          if (metadata?.graphData) {
            updateShareTemplateData.section[0].widgets[widget_index].graphData =
              null;
          }
          if (metadata?.persist_graphdata) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (metadata?.deep_dive_on) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }
    } else if (
      panes?.[index]?.is_widget_maker_open_obj?.open_flag ||
      pathName === "widgetMaker" ||
      pathName === "edit-widget"
    ) {
      // Widget Maker View
      setPillsName(name);
      if (!isPreviewState) {
        let filter_by_data;
        let postcard_pills_filter;
        if (name === null) {
          filter_by_data = null;
          postcard_pills_filter = null;
        } else {
          let attName =
            widgetGraphConfig?.filter_by?.length > 0
              ? widgetGraphConfig?.filter_by?.[0]?.attribute
              : widgetGraphConfig?.breakdown_by?.[0]?.attribute;

          if (
            widgetGraphConfig?.filter_by?.length > 0 ||
            widgetGraphConfig?.breakdown_by?.length > 0
          ) {
            filter_by_data = {
              attribute: attName,
              data: filterPills,
            };
            postcard_pills_filter = {
              attribute: attName,
              type: "varchar",
              columns: [{ name: name, type: "include" }],
            };
          }
        }

        dispatch(
          setY_attribute({
            ...widgetGraphConfig,
            [`order_by`]: (widgetGraphConfig?.chart_type === "post-card" ||
              widgetGraphConfig?.chart_type === "review-card") && {
              ...widgetGraphConfig?.order_by,
              offset: 0,
            },
            [`filter_by_data`]: filter_by_data,
            [`postcard_pills_filter`]: postcard_pills_filter,
          })
        );
      }
    } else {
      // View Dashboard View
      setPillsName(name);
      if (!isPreviewState) {
        let filter_by_data;
        let postcard_pills_filter;
        let updatedOrderBy;
        if (name === null) {
          updatedOrderBy = {
            attribute: metadata?.order_by?.attribute,
            sort_order: metadata?.order_by?.sort_order,
            offset: 0,
          };
          filter_by_data = null;
          postcard_pills_filter = null;
        } else {
          let attName = metadata?.y_axes?.[0]?.attribute;
          if (metadata?.y_axes?.length > 0) {
            filter_by_data = {
              attribute: metadata?.y_axes?.[0]?.attribute,
              data: filterPills,
            };
            postcard_pills_filter = {
              attribute: attName,
              type: "varchar",
              columns: [{ name: name, type: "include" }],
            };
          }
          updatedOrderBy = {
            attribute: metadata?.order_by?.attribute,
            sort_order: metadata?.order_by?.sort_order,
            offset: 0,
          };
        }
        if (metadata) {
          let updatePanes = [...panes];

          if (section_index >= 0) {
            if (
              metadata?.chart?.chart_type === "post-card" ||
              metadata?.chart?.chart_type === "review-card"
            ) {
              updatePanes[index].sections[section_index].widgets[
                widget_index
              ].order_by = updatedOrderBy;
            }
            if (metadata?.y_axes?.length) {
              updatePanes[index].sections[section_index].widgets[
                widget_index
              ].filter_by_data = filter_by_data;
              updatePanes[index].sections[section_index].widgets[
                widget_index
              ].filter_by = postcard_pills_filter;
            }

            if (metadata?.graphData) {
              updatePanes[index].sections[section_index].widgets[
                widget_index
              ].graphData = null;
            }
            if (metadata?.persist_graphdata) {
              updatePanes[index].sections[section_index].widgets[
                widget_index
              ].persist_graphdata = null;
            }

            if (metadata?.deep_dive_on) {
              updatePanes[index].sections[section_index].widgets[
                widget_index
              ].deep_dive_on = null;
            }
          } else {
            if (
              metadata?.chart?.chart_type === "post-card" ||
              metadata?.chart?.chart_type === "review-card"
            ) {
              updatePanes[index].section[0].widgets[widget_index].order_by =
                updatedOrderBy;
            }
            if (metadata?.y_axes?.length) {
              updatePanes[index].section[0].widgets[
                widget_index
              ].filter_by_data = filter_by_data;
              updatePanes[index].section[0].widgets[widget_index].filter_by =
                postcard_pills_filter;
            }

            if (metadata?.graphData) {
              updatePanes[index].section[0].widgets[widget_index].graphData =
                null;
            }
            if (metadata?.persist_graphdata) {
              updatePanes[index].section[0].widgets[
                widget_index
              ].persist_graphdata = null;
            }
            if (metadata?.deep_dive_on) {
              updatePanes[index].section[0].widgets[widget_index].deep_dive_on =
                null;
            }
          }
          dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
        }
      }
    }
  };

  const showFilterByHeader = useMemo(() => {
    let pathName = window.location.pathname?.split("/")?.[1];
    let index = getPaneIndex(panes, activeKey);
    if (
      pathName === "edit-dashboard" ||
      pathName === "create-dashboard" ||
      isPreviewState ||
      (!deepDive &&
        (((pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
          panes?.[index]?.isDeepDiveDashboard) ||
          shareTemplateData?.isDeepDiveDashboard ||
          screen?.isDeepDiveDashboard)) ||
      shareTemplateData
    ) {
      return (
        metadata?.y_axes?.length > 0 &&
        metadata?.chart?.chart_settings?.show_header !== false
      );
    } else if (deepDive) {
      return true;
    } else if (
      panes?.[index]?.is_widget_maker_open_obj?.open_flag ||
      pathName === "widgetMaker" ||
      pathName === "edit-widget"
    ) {
      return (
        widgetGraphConfig?.chart_settings?.show_header !== false &&
        (widgetGraphConfig?.filter_by?.length > 0 ||
          widgetGraphConfig?.breakdown_by?.length > 0)
      );
    }
    return (
      metadata?.y_axes?.length > 0 &&
      metadata?.chart?.chart_settings?.show_header !== false
    );
  }, [widgetGraphConfig, metadata, filterPills]);

  return (
    <div
      id={`post_card_${section_index ? section_index : "section_index"}_${
        widget_index ? widget_index : "widget_index"
      }`}
      className={`w-100 wm-chart-cards text-right`}
    >
      {showFilterByHeader &&
      (widgetGraphConfig?.filter_by?.[0]?.trace_name ||
        widgetGraphConfig?.breakdown_by?.[0]?.trace_name ||
        metadata?.y_axes?.[0]?.trace_name) ? (
        <div
          className={`text_regular font-weight500 text-left w-100 border-bottom border-color bg__white ${
            PdfDownloadStatus || PptGeneratingStatus ? "" : "p-15"
          }`}
          style={
            PdfDownloadStatus || PptGeneratingStatus
              ? {
                  padding: "0.5rem 1rem",
                  // color: "var(--locobuzz-primary-text-color)",
                }
              : // : authParams?.screen_id
                // ? { color: "var(--locobuzz-chart-text--color)" }
                // : authParams?.theme_type === "1"
                // ? { color: "var(--secondary-light-color)" }
                // : { color: "var(--locobuzz-primary-text-color)" }
                {}
          }
        >
          {widgetGraphConfig?.filter_by?.[0]?.trace_name &&
          widgetGraphConfig?.filter_by?.[0]?.trace_name !==
            widgetGraphConfig?.filter_by?.[0]?.attribute
            ? widgetGraphConfig?.filter_by?.[0]?.trace_name
            : widgetGraphConfig?.filter_by?.[0]?.attribute
            ? allAttributesList?.[widgetGraphConfig?.filter_by?.[0]?.attribute]
            : widgetGraphConfig?.breakdown_by?.[0]?.trace_name &&
              widgetGraphConfig?.breakdown_by?.[0]?.trace_name !==
                widgetGraphConfig?.breakdown_by?.[0]?.attribute
            ? widgetGraphConfig?.breakdown_by?.[0]?.trace_name
            : widgetGraphConfig?.breakdown_by?.[0]?.attribute
            ? allAttributesList?.[
                widgetGraphConfig?.breakdown_by?.[0]?.attribute
              ]
            : metadata?.y_axes &&
              metadata?.y_axes?.[0]?.trace_name &&
              metadata?.y_axes?.[0]?.trace_name !==
                metadata?.y_axes?.[0]?.attribute
            ? metadata?.y_axes?.[0]?.trace_name
            : metadata?.y_axes &&
              allAttributesList?.[metadata?.y_axes?.[0]?.attribute]}{" "}
          Based On{" "}
          {widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
          allAttributesList?.[widgetGraphConfig?.y_axis?.y_series_1?.attribute]
            ? allAttributesList?.[
                widgetGraphConfig?.y_axis?.y_series_1?.attribute
              ]
            : (widgetGraphConfig?.chart_type === "post-card" ||
                widgetGraphConfig?.chart_type === "review-card") &&
              (widgetGraphConfig?.filter_by?.length > 0 ||
                widgetGraphConfig?.breakdown_by?.length > 0) &&
              allAttributesList?.[widgetGraphConfig?.order_by?.attribute]
            ? allAttributesList?.[widgetGraphConfig?.order_by?.attribute]
            : (metadata?.chart?.chart_type === "post-card" ||
                metadata?.chart?.chart_type === "review-card") &&
              metadata?.order_by?.attribute &&
              allAttributesList?.[metadata?.order_by?.attribute]
            ? allAttributesList?.[metadata?.order_by?.attribute]
            : !IsEmpty(graphConditionConfig?.["sort_options-card_widgets"]) &&
              graphConditionConfig?.["sort_options-card_widgets"]?.[chart_type]
                ?.length > 0 &&
              Array.isArray(
                graphConditionConfig?.["sort_options-card_widgets"]?.[
                  chart_type
                ]
              ) &&
              graphConditionConfig?.["sort_options-card_widgets"]?.[
                chart_type
              ]?.findIndex(
                (el) => el?.attribute === metadata?.order_by?.attribute
              ) !== -1
            ? graphConditionConfig?.["sort_options-card_widgets"]?.[
                chart_type
              ]?.find((el) => el?.attribute === metadata?.order_by?.attribute)
                ?.trace_name
            : metadata?.y_series && metadata?.y_series?.[0]?.trace_name}
        </div>
      ) : (
        ""
      )}
      <div
        className={`d-flex flex-wrap w-100 border-left ${
          PdfDownloadStatus || PptGeneratingStatus
            ? "border-top border-color"
            : ""
        } justify-content-between postCardFilter__wrapper`}
        // style={
        //   PdfDownloadStatus || PptGeneratingStatus
        //     ? {}
        //     : { maxWidth: "calc(100% - 3rem)" }
        // }
      >
        {filterPills?.map((d, i) => {
          if (PdfDownloadStatus && i > 4) {
            return null;
          }
          return (
            <div
              className={`pill-item ${
                pillsName === d.text ? "active" : ""
              } portlet1 border-color
              ${
                PdfDownloadStatus || PptGeneratingStatus
                  ? "border-bottom border-right p-5"
                  : "border-bottom border-right pt-4 pb-4"
              } text-center 
              ${d?.highlight ? "is-highlighted-pill" : ""}
              ${isPreviewState ? "is-preview-mode" : ""}
              ${isPreviewState || PdfDownloadStatus ? "" : "cursor-pointer"}`}
              onClick={() =>
                !isPreviewState &&
                !PdfDownloadStatus &&
                !d?.highlight &&
                postCardFilter(d?.percent === null ? null : d.text)
              }
              style={{
                //width: "16rem",
                // border:
                //   !isPreviewState && d?.highlight
                //     ? "0.1rem solid #007bff"
                //     : authParams?.theme_type === "1"
                //     ? "0.1rem solid transparent"
                //     : "0.1rem solid #c3cbd7",
                // boxShadow:
                //   !isPreviewState && d?.highlight
                //     ? "0 0 0.6rem #678bff80"
                //     : "0 0 0.6rem #c3cbd780",
                //borderRadius: "0.4rem",
                backgroundColor:
                  d?.color && d?.color?.trim() != "#000000"
                    ? d?.color?.trim() + "30"
                    : d?.highlight
                    ? "#678bff33"
                    : authParams?.theme_type === "1"
                    ? ""
                    : "",
                // ? "var(--cc-widget-background-color)" //ChangeForCC
                // : "var(--cc-widget-background-color)",
                flex:
                  PdfDownloadStatus || PptGeneratingStatus
                    ? "1 0 calc(20% - 1.5rem)"
                    : "1 0 calc(25% - 0.5rem)",
                width: PptGeneratingStatus || PdfDownloadStatus ? "20%" : "",
              }}
            >
              <>
                {/* here start */}
                <div
                  //style={{ maxWidth: "14rem" }}
                  className="wm-chart-card-title font-weight500 mb-1 line-height-normal"
                >
                  <Tooltip
                    title={d?.text}
                    placement="top"
                    className="text-ellipsis d-block"
                  >
                    <span
                    // style={{ color: "var(--locobuzz-chart-text--color)" }}
                    >
                      {d?.text?.length >= 40
                        ? `${d?.text.substring(0, 40)}...`
                        : d?.text}
                    </span>
                  </Tooltip>
                </div>
                <div className="d-flex align-items-baseline justify-content-center">
                  <Tooltip
                    placement="bottom"
                    title={d?.value?.toLocaleString()}
                  >
                    <span
                      className={`wm-chart-card-value mr-1`}
                      // style={{
                      //   color: authParams?.screen_id
                      //     ? "var(--locobuzz-chart-text--color)"
                      //     : "",
                      // }}
                    >
                      {kFormatter(d?.value)}
                    </span>
                  </Tooltip>
                  {d?.percent ? (
                    <span className="d-flex align-items-center font-size12 font-weight600 text-blue cursor-default ml-1 no--wrap">
                      <span
                        className="pie__of--share mr-1"
                        style={{
                          border:
                            d?.percent === null ? "" : "0.2rem solid #185EDF",
                          backgroundImage:
                            d?.percent === null
                              ? ""
                              : "conic-gradient(" +
                                "#185EDF " +
                                d?.percent * 3.6 +
                                "deg,#ffff " +
                                d?.percent * 3.6 +
                                "deg)",
                        }}
                      ></span>

                      <span
                        style={{
                          pointerEvents: isPreviewState ? "none" : "",
                        }}
                        className="text-blue font-size12 font-weight500"
                      >
                        {d?.percent === null ? "" : d?.percent}{" "}
                        {d?.percent === null ? "" : "%"}
                      </span>
                    </span>
                  ) : (
                    <span className="text_regular font-size12 font-weight600 text-gray"></span>
                  )}
                </div>
              </>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(PostCardFilters, isEqual);
